import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import template from './live.vue';
import jQuery from 'jquery';

// Components
import LeftSide from '../../components/left-side/index';
import RightSide from '../../components/right-side/index';
import * as Store from './../../store';

export interface LiveData {
    _id: string;

    transactions: any[];

    auction: any;
    lots: any[];
    selectedLot: any;
    currentLot?: any;
    currentBid?: any;
    activeLot: any;
    lotActive: number;
    activeLotStatus: number;

    lastLog?: any;

    prevPrice?: number;
    currentPrice?: number;
    nextPrice?: number;

    prices: any;

    currentWinner?: any;
    winnerIsMe: boolean;
    auctionUserStatus?: number;
    auctionUser?: any;
}

@Component({
    mixins: [template],
    components: {
        LeftSide,
        RightSide,
    },
})
export default class LiveAuction extends ComponentWithSocket {
    data: LiveData = {
        _id: '',

        auction: undefined,

        lots: [],

        transactions: [],

        selectedLot: undefined,
        currentLot: undefined,

        currentBid: undefined,

        activeLot: undefined,
        lotActive: 0,
        activeLotStatus: 0,

        lastLog: undefined,

        prevPrice: 0,
        currentPrice: 0,
        nextPrice: 0,

        prices: {},

        currentWinner: undefined,
        winnerIsMe: false,

        auctionUserStatus: 0,
        auctionUser: undefined,
    };

    buttonLoading: boolean = false;
    isConnected: boolean = true;
    lastEnterSignal: number = 0;

    constructor() {
        super();

        // Assign session values to store for global dispatch
        this.wsListener.onGet(
            'auctions.find',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (!success) return;

                // Data about auction
                this.data.auction = data;

                if (data.streamServerUrl) {
                    Store.commitLiveStreamUrl(
                        this.$store,
                        data.streamServerUrl,
                    );
                }

                if (data.streamId) {
                    Store.commitLiveStreamId(this.$store, data.streamId);
                }

                // Get current data, user and lots
                this.wsListener.sendGet('lots', {
                    auction: this.data.auction._id,
                    populateAuthor: true,
                });
                this.wsListener.sendGet('live.current', {
                    auction: this.data.auction._id,
                    populateAuthor: true,
                });
                this.wsListener.sendGet('live.user', {
                    auction: this.data.auction._id,
                });
                this.wsListener.sendGet('live.transactions', {
                    auction: this.data.auction._id,
                });
            },
        );

        this.wsListener.onGet('lots', (success: boolean, data: any) => {
            if (!success) return;

            this.data.lots = data;
        });

        this.wsListener.onGet('lots.updated', (success: boolean, data: any) => {
            let updatedLot = data;

            for (let lotIndex in this.data.lots) {
                if (updatedLot._id == this.data.lots[lotIndex]._id) {
                    let liked = this.data.lots[lotIndex].liked;
                    this.data.lots[lotIndex] = updatedLot;
                    this.data.lots[lotIndex].liked = liked;
                    break;
                }
            }
        });

        this.wsListener.onGet(
            'live.transactions',
            (success: boolean, data: any) => {
                if (!success) return;

                this.data.transactions = data;
            },
        );

        this.wsListener.onGet('live.user', (success: boolean, data: any) => {
            if (!success) return;

            // Current auction user, if logged in
            // auctionUserStatus -> Statuses:
            // 1 = not logged in;
            // 2 = logged in, but not verifier;
            // 3 = logged in, verified, but not joined the current auction
            // 4 = use can bid, all the verifications steps was passed

            this.data.auctionUserStatus = data.auctionUserStatus;
            this.data.auctionUser = data.auctionUser;
            this.buttonLoading = false;
        });

        this.wsListener.onGet('live.current', (success: boolean, data: any) => {
            if (!success) return;

            this.wsListener.sendGet('live.transactions', {
                auction: this.data.auction._id,
            });

            Store.commitPricesLoaderVisibility(this.$store, false);

            // This is the Live NOW lot
            this.data.currentLot = data.lot;

            if (data.lot) {
                this.data.activeLot = data.lot.position - 1;
                this.$store.state.currentShownLot = data.lot.position - 1;
                this.data.lotActive = 1;
                this.data.activeLotStatus = data.lot.status;

                // if ( !this.$store.state.currentShownLot ) {

                let currentItemInCarouselOffsetLet: number =
                        this.data.activeLot * 98,
                    carouselWidth: any = jQuery(
                        '.right-side-lots-list__items .owl-stage-outer',
                    ).outerWidth(),
                    allItemsWidth: any = jQuery(
                        '.right-side-lots-list__items .owl-stage',
                    ).outerWidth();

                if (carouselWidth < allItemsWidth) {
                    jQuery('.right-side-lots-list__items .owl-stage').css(
                        'transform',
                        `translate3d(-${currentItemInCarouselOffsetLet}px, 0px, 0px)`,
                    );
                }
                // }
            } else {
                this.data.lotActive = 0;
            }

            // This is the current winner user. You can get the paddle number by currentWinner.paddleNumber
            this.data.currentWinner = data.winner;

            // If i"m the winner the bid button will be disabled
            this.data.winnerIsMe = data.winnerIsMe;

            // If current bid exists and currentBid.status == 0 then i already bidded for this price level, so disabble the button
            this.data.currentBid = data.bid;

            // State
            this.buttonLoading = false;

            // Data for live text
            this.data.lastLog = data.log;

            // Data for prices
            // console.log(data);
            this.data.prevPrice = data.prices.prev ? data.prices.prev.price : 0;
            this.data.currentPrice = data.prices.current
                ? data.prices.current.price
                : 0;
            this.data.nextPrice = data.prices.next ? data.prices.next.price : 0;
            this.data.prices = data.prices;
            // console.log(this.data.prevPrice, this.data.currentPrice, this.data.nextPrice);
        });

        this.wsListener.onPost('live.bid', (success: boolean, data: any) => {
            if (!success) {
                alert(data);
            }
        });

        this.wsListener.onPost(
            'auctions.subscribe',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.auction.subscribed = data.subscribed;
                } else {
                    alert(data);
                }
            },
        );

        // Notify the server i'm online in this live if the reconnection is made
        this.wsListener.onOpenMultiple(() => {
            this.isConnected = true;

            this.sendIsLiveSignal();
        });

        this.wsListener.onClose(() => {
            console.log('Your session was closed');
            this.isConnected = false;
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this.wsListener.sendPost('live.state.close', {
            auction: this.data._id,
        });

        this._beforeLeave(to, from);

        next();
    }

    created() {
        this.data._id = this.$root.$route.params.id;
    }

    mounted() {
        this.sendIsLiveSignal();

        jQuery('body').addClass('app-loaded');
    }

    sendIsLiveSignal() {
        let currentTime = new Date().getTime();

        if (this.lastEnterSignal && currentTime - this.lastEnterSignal < 1000) {
            return;
        }

        let auctionId = this.data ? this.data._id : undefined;

        if (!auctionId) return;

        this.lastEnterSignal = currentTime;

        for (let timeDelay of [100, 250]) {
            setTimeout(() => {
                // When the user focus the window send enter signal
                this.wsListener.sendPost('live.state.enter', {
                    auction: auctionId,
                });

                // Reaload the auction
                this.wsListener.sendGet('auctions.find', { _id: auctionId });
            }, timeDelay);
        }
    }

    doAuctionJoin() {
        if (!this.$root.$options || !this.$root.$options.router) {
            return;
        }

        if (this.data.auctionUserStatus == 0) {
            this.$root.$options.router.push(
                `/login?auction=${this.data.auction._id}`,
            );
        } else if (this.data.auctionUserStatus == 1) {
            this.$root.$options.router.push(
                `/verify?auction=${this.data.auction._id}`,
            );
        } else if (this.data.auctionUserStatus == 2) {
            this.wsListener.sendPost('auctions.subscribe', {
                auction: this.data.auction._id,
                subscribe: true,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/live/index.ts